import { Commercial } from '../../../types/api/endpoints/commercial/commercial.types';
import { COMMERCIAL_ENDPOINTS } from '../../../utils/api/endpoints/commercialEndpoints';

const PREFIX = '[commerciauxDIRQuery]';

export const commerciauxDIRQuery = async () => {
  console.log(PREFIX, `Fetching commerciaux DIR...`);
  const response = await COMMERCIAL_ENDPOINTS.getAllList();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received commerciaux DIR.`);
  return json as Commercial[];
};
